import React from "react"
import * as styles from "./BgColor.module.scss"

type BgColorProps = {
  color?: HarviaBackgroundColor | string
  id?: string
  className?: string
  children: React.ReactNode
}

export type HarviaBackgroundColor =
  | "Transparent"
  | "SemiTransparent"
  | "BrandRed"
  | "BrandBlack"
  | "BrandWhite"
  | "BrandGreyWarmLight"
  | "BrandGreyWarmDark"
  | "Semi Transparent"
  | "Brand Red"
  | "Brand Black"
  | "Brand White"
  | "Brand Grey Warm Light"
  | "Brand Grey Warm Dark"

const BgColor = (props: BgColorProps) => {
  // console.debug("Rendering BgColor", props)
  const { color = "BrandWhite" } = props

  const colorClass = color ? styles[`bg${color.replace(/\s/g, "")}`] : ""

  return (
    <div id={props.id} className={`${props.className}  ${colorClass}`}>
      {props.children}
    </div>
  )
}

export default BgColor
